import { createPortal } from "react-dom";
import { PhoneCall } from "lucide-react";

const ADMIN_CALL_NUMBER = "919414156086";

export default function FloatingCall() {
  const href = `tel:+91${ADMIN_CALL_NUMBER.slice(2)}`;

  const button = (
    <a
      href={href}
      aria-label="Call now"
      title="Call now"
      className="fixed bottom-[4.5rem] right-5 z-[9998] inline-flex items-center gap-2 rounded-full bg-orange-600 px-4 py-3 text-white shadow-2xl shadow-black/20 transition hover:scale-105 hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-orange-500/40"
    >
      <PhoneCall className="h-5 w-5" />
      <span className="hidden sm:inline text-sm font-semibold">Call now</span>
    </a>
  );

  if (typeof document === "undefined") {
    return button;
  }

  return createPortal(button, document.body);
}
